import React from 'react';
import StationLogDashboard from './StationLogDashboard';

const StationLog: React.FC = () => {
  return <StationLogDashboard />;
};

export default StationLog; 